import { SnippetsV2Url } from "../../../../../constants/apiUrls";
import { DisplayMessage } from "../../../../../services/helpers";
import { UpdateRequest } from "../../../../../services/requestHelpers";
import { HttpMethods } from "../../../../../utils/constants";

export const createSnippet = async (data) => {
const response = await UpdateRequest(SnippetsV2Url(), data, HttpMethods.Post);
    let result = null;

    try {
      const text = await response.text();
      result = text ? JSON.parse(text) : null;
    } catch (parseError) {
      result = null;
    }

    if (!response.ok) {
      if (result?.errors?.length) {
        for (const err of result.errors) {
          DisplayMessage(err, "error");
        }
      } 
      return undefined;
    }
    return result; 
};